module.exports = __webpack_public_path__ + "img/logo-form.e9f796f9.png";